export const bytesToMB = (bytes: number) => bytes / 1024 / 1024;
export const mbToBytes = (mb: number) => mb * 1024 * 1024;